export default /* glsl */`

uniform float sizeX;
uniform float sizeY;
uniform mat3 uvTransform;

varying vec2 vUv;

void main() {

    vUv = uv;

    float resizeX = position.x;
    float resizeY = position.y;

    if (abs(resizeX) > abs(sizeX * 0.5)) resizeX = 1920.0 * abs(resizeX) / resizeX;
    if (abs(resizeY) > abs(sizeY * 0.5)) resizeY = 1920.0 * abs(resizeY) / resizeY;

    vec4 projection = projectionMatrix * viewMatrix * modelMatrix * vec4( resizeX, resizeY, position.z, 1.0 );

    gl_Position = projection;

}
`;
